export const NAVIGATION_ITEMS_MAX_WIDTH = 656;
